import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

/**
 * Component for a delayed closing button that automatically closes after two seconds. If nothing is pressed.
 */
@Component({
    selector: 'app-delayed-close-overlay',
    templateUrl: './delayed-close-overlay.component.html',
    styleUrls: ['./delayed-close-overlay.component.scss'],
    standalone: false,
})
export class DelayedCloseOverlayComponent implements OnInit, OnDestroy {
    /**
     * The active color of the button
     */
    @Input() activeColor = '#EB5153';
    /**
     * The inactive color of the button
     */
    @Input() inactiveColor = '#DCDCDC';
    /**
     * The icon to show on the button
     */
    @Input() icon = 'close';

    /**
     * Emitted when the button was pressed before the timeout
     */
    @Output() cancel = new EventEmitter<void>();
    /**
     * Emitted when the timeout ran out before the button was pressed
     */
    @Output() finished = new EventEmitter<void>();

    percent = 0;
    private interval?: any;

    ngOnInit() {
        this.start();
    }

    ngOnDestroy(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    get style(): { [key: string]: string } {
        return {
            background: `linear-gradient(to top, ${this.activeColor} ${this.percent}%, transparent 0%)`,
        };
    }

    start(): void {
        this.percent = 0;
        this.interval = setInterval(() => {
            this.percent += 0.5;

            if (this.percent >= 100) {
                this.finished.emit();
                clearInterval(this.interval);
            }
        }, 10);
    }

    stop(): void {
        this.cancel.emit();
        this.percent = 0;
        clearInterval(this.interval);
    }
}
